import { render } from "./StoreCard.vue?vue&type=template&id=12ec4424"
import script from "./StoreCard.vue?vue&type=script&lang=js"
export * from "./StoreCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__